import { useContext } from "react";
import {
  ConversationDetailsContext,
  useEmailReply,
  usePhoneReply,
  useTextReply
} from "../../context";
import { ConversationTypeEnum } from "@coxauto-ui/cxm/communications/interfaces";
import { BaseMessageInput, BaseMessageInputProps } from "./base-message-input";

export type MessageInputProps = Omit<
  BaseMessageInputProps,
  "replyText" | "setReplyText" | "label" | "placeholder" | "showWYSIWYG"
>;

export function MessageInput(props: MessageInputProps) {
  const { currentConversationType } = useContext(ConversationDetailsContext);
  const emailReply = useEmailReply();
  const textReply = useTextReply();
  const phoneReply = usePhoneReply();

  if (currentConversationType === ConversationTypeEnum.EMAIL) {
    return (
      <BaseMessageInput
        {...props}
        replyText={emailReply.replyText}
        setReplyText={emailReply.setReplyText}
        showWYSIWYG={true}
      />
    );
  }

  if (currentConversationType === ConversationTypeEnum.TEXT) {
    return (
      <BaseMessageInput
        {...props}
        replyText={textReply.replyText}
        setReplyText={textReply.setReplyText}
      />
    );
  }

  if (currentConversationType === ConversationTypeEnum.PHONE) {
    return (
      <BaseMessageInput
        {...props}
        label="Call Notes"
        placeholder="CAI is not responsible for calls placed to customers on do not call lists"
        replyText={phoneReply.replyText}
        setReplyText={phoneReply.setReplyText}
      />
    );
  }

  return null;
}
